import React, {useRef, useEffect} from 'react';
import {SEND_PROVIDERS} from '../../../constants';
import MappSendProviderParams from './MappSendProviderParams';

const buildDefaultParams = (provider, previous = {}) => {
    switch (provider) {
        case SEND_PROVIDERS.MAPP:
            return {
                invitationEmailMessageId: previous.invitationEmailMessageId || '',
                reminderEmailMessageId: previous.reminderEmailMessageId || '',
                invitationSMSMessageId: previous.invitationSMSMessageId || '',
                reminderSMSMessageId: previous.reminderSMSMessageId || '',
            };
        case SEND_PROVIDERS.PINPOINT:
        default:
            return {};
    }
};

const SendProviderParams = ({values, errors, touched, setFieldValue, validationSchema}) => {
    const lastProvider = useRef(values.sendProvider);

    useEffect(() => {
        if (lastProvider.current !== values.sendProvider) {
            lastProvider.current = values.sendProvider;
            const fallbackParams = buildDefaultParams(values.sendProvider, values.sendProviderParams || {});
            setFieldValue('sendProviderParams', fallbackParams);
        }
    }, [values.sendProvider, values.sendProviderParams, setFieldValue, validationSchema]);

    switch (values.sendProvider) {
        case SEND_PROVIDERS.MAPP:
            return <MappSendProviderParams values={values} errors={errors} touched={touched}
                setFieldValue={setFieldValue} validationSchema={validationSchema} />;
        case SEND_PROVIDERS.PINPOINT:
        case SEND_PROVIDERS.NONE:
        default:
            return <div />;
    }
};

export default SendProviderParams;
